
import Vue, { PropType } from 'vue'
import { Block } from '~/domain/interfaces/BlockTypes'

export default Vue.extend({
  name: 'CommonQuote',
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },
})
